// Previous React path deployment:
// const apiurl = 'https://meraqui.com/react/api/';
const resolveApiUrl = () => {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE.replace(/\/?$/, "/");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    const host = window.location.hostname;
    if (host === "aip.meraqui.com" || host === "karam.meraqui.com") {
      return `${window.location.origin}/api/`;
    }
  }

  return "https://aip.meraqui.com/api/";
};

const apiurl = resolveApiUrl();
// const apiurl = 'http://localhost/deployaip/dapis/';
export default apiurl;
